module.exports = __webpack_public_path__ + "static/img/tc-mobile.67e6428b.png";